var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ReactDOM from 'react-dom';
import { cx, css } from '@emotion/css';
import { BlockButton, CustomButton, FontColorButton, FontsizeButton, ImageButton, LinkButton, MarkButton, RemoveLinkButton, SharedAppConsumer, TableButton, ToggleEditableButtonButton, YoutubeButton, EmojiButton } from './Wysiwyg';
import { defaultColors } from './InitilValue';
export const CustomToolbar = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement(Menu, Object.assign({}, props, { ref: ref, className: className }));
});
export const ToolbarGroup = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className, children } = _a, props = __rest(_a, ["as", "className", "children"]);
    return (React.createElement(Component, Object.assign({}, props, { className: `$react-slate-wysiwyg toolbargroup ${className}` }), children));
});
export const ToolbarButton = React.forwardRef((_a, ref) => {
    var { className, active, reversed, colors } = _a, props = __rest(_a, ["className", "active", "reversed", "colors"]);
    if (props && props.name && props.name.format === 'fontSizeButton') {
        return React.createElement(React.Fragment, null, props.children);
    }
    else {
        if (colors) {
            return (React.createElement("button", Object.assign({ type: "button" }, props, { ref: ref, className: cx(className, css `
                                cursor: pointer !important;
                                color: ${reversed ? (active ? colors.reverse.activeColor : colors.reverse.color) : active ? colors.normal.activeColor : colors.normal.color} !important;
                            `) })));
        }
        else {
            return (React.createElement("button", Object.assign({ type: "button" }, props, { ref: ref, className: cx(className, css `
                                cursor: pointer !important;
                            `) })));
        }
    }
});
export const EditorValue = React.forwardRef((_a, ref) => {
    var { className, value } = _a, props = __rest(_a, ["className", "value"]);
    const textLines = value.document.nodes
        .map((node) => node.text)
        .toArray()
        .join('\n');
    return (React.createElement("div", Object.assign({ ref: ref }, props, { className: cx(className, css `
                        margin: 30px -20px 0;
                    `) }),
        React.createElement("div", { className: css `
                        font-size: 14px;
                        padding: 5px 20px;
                        color: #404040;
                        border-top: 2px solid #eeeeee;
                        background: #f8f8f8;
                    ` }, "Slate's value as text"),
        React.createElement("div", { className: css `
                        color: #404040;
                        font: 12px monospace;
                        white-space: pre-wrap;
                        padding: 10px 20px;
                        div {
                            margin: 0 0 0.5em;
                        }
                    ` }, textLines)));
});
const iconButton = (_a, ref) => {
    var { buttonIcons } = _a, rest = __rest(_a, ["buttonIcons"]);
    return (React.createElement(React.Fragment, null, buttonIcons.length === 0 ? (React.createElement("i", null, "\u274C")) : (buttonIcons.map((icon) => {
        return React.createElement("i", Object.assign({}, rest, { ref: ref, key: icon, className: icon }));
    }))));
};
export const Icon = React.forwardRef(iconButton);
export const Instruction = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("div", Object.assign({}, props, { ref: ref, className: className }));
});
export const Menu = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("div", Object.assign({}, props, { ref: ref, className: className }));
});
export const Portal = (props) => {
    const child = props.children;
    return typeof document === 'object' ? ReactDOM.createPortal(child, document.body) : null;
};
export const Toolbar = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement(Menu, Object.assign({}, props, { ref: ref, className: className }));
});
export const ToolbarItem = React.forwardRef((_a, ref) => {
    var { type = '', format = '', icon = '', text = '', colors = defaultColors } = _a, rest = __rest(_a, ["type", "format", "icon", "text", "colors"]);
    let element = React.createElement("button", null);
    if (type === 'block') {
        element = (React.createElement(SharedAppConsumer, null, (propps) => {
            return React.createElement(BlockButton, Object.assign({ ref: ref, format: format, icon: icon, colors: propps.colors }, propps, rest));
        }));
    }
    if (type === 'mark') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(MarkButton, Object.assign({ ref: ref, format: format, icon: icon, colors: props.colors }, props, rest));
        }));
    }
    if (type === 'fontColor') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(FontColorButton, Object.assign({ ref: ref, format: format }, props, rest));
        }));
    }
    if (type === 'fontsize') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(FontsizeButton, Object.assign({ ref: ref, format: format, icon: icon, colors: colors }, props, rest));
        }));
    }
    if (type === 'table') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(TableButton, Object.assign({ ref: ref, format: format, icon: icon, colors: colors }, props, rest));
        }));
    }
    if (type === 'link') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(LinkButton, Object.assign({ ref: ref, format: format, icon: icon, colors: props.colors }, props, rest));
        }));
    }
    if (type === 'removelink') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(RemoveLinkButton, Object.assign({ ref: ref, format: format, icon: icon, colors: colors }, props, rest));
        }));
    }
    if (type === 'image') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(ImageButton, Object.assign({ ref: ref, format: format, icon: icon, colors: colors }, props, rest));
        }));
    }
    if (type === 'cta') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(ToggleEditableButtonButton, Object.assign({ ref: ref, format: format, icon: icon, colors: colors }, props, rest));
        }));
    }
    if (type === 'youtube') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(YoutubeButton, Object.assign({ ref: ref, format: format, icon: icon, colors: colors }, props, rest));
        }));
    }
    if (type === 'emoji') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(EmojiButton, Object.assign({ ref: ref, format: format, icon: icon }, props, rest));
        }));
    }
    if (type === 'custom') {
        element = (React.createElement(SharedAppConsumer, null, (props) => {
            return React.createElement(CustomButton, Object.assign({ ref: ref, text: text, format: format, icon: icon, colors: colors }, props, rest));
        }));
    }
    return element;
});
//# sourceMappingURL=components.js.map